export const selectTaxonomyDescriptions = (state) => state.taxonomyDescriptions.taxonomyDescriptions;
export const selectTaxonomyDescriptionsLoading = (state) => state.taxonomyDescriptions.loading;